import { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiCssBaseline: Components<CssVarsTheme>['MuiCssBaseline'] = {
  styleOverrides: (theme) => ({
    '*': {
      boxSizing: 'border-box',
      '&::-webkit-scrollbar': {
        width: 6,
        height: 6,
        position: 'absolute'
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.vars.palette.neutral['0'],
        borderRadius: 4
      }
    }
  })
};
